import React, { useEffect, useState } from 'react'
import { Button, Input, message, Modal, Select, Table, Typography } from 'antd'
import HighlighterWrapper from '../HighlighterWrapper'
import { getEstimateFieldsByEmbedding } from '../../services/estimate-field'
import uniq from 'lodash/uniq'
import usePagination from '../hooks/usePagination'

const { Text } = Typography
const { Search } = Input

const EstimateAutoSuggestion = ({ isModalOpen, selectedRecord, project, onUpdate, handleCancel }) => {
  const [isLoading, setIsLoading] = useState(false)
  const [searchRequest, setSearchRequest] = useState('')
  const [categoryOptions, setCategoryOptions] = useState([])
  const [selectedCategory, setSelectedCategory] = useState(null)
  const [estimatesData, setEstimatesData] = useState([])
  const [filteredEstimatesData, setFilteredEstimatesData] = useState([])
  const [tablePagination, page, pageSize, setPage] = usePagination(filteredEstimatesData.length)

  const getEstimatesByQuery = (query, subQuery) => {
    setIsLoading(true)
    getEstimateFieldsByEmbedding(project, query.trim(), subQuery.trim())
      .then((response) => {
        setEstimatesData(response.data)
        setFilteredEstimatesData(response.data)
        setCategoryOptions(
          uniq(response.data.map((item) => item.category)).map((item) => ({ value: item, label: item }))
        )
        // setIsModalOpen(true)
        setPage(1)
      })
      .finally(() => setIsLoading(false))
  }

  useEffect(() => {
    if (isModalOpen) {
      getEstimatesByQuery(selectedRecord?.name || '', selectedRecord?.applicationItemName || '')
    }
  }, [isModalOpen])

  useEffect(() => {
    const filteredData = estimatesData.filter((item) => item.name.toLowerCase().includes(searchRequest.toLowerCase()))
    if (selectedCategory) {
      setFilteredEstimatesData(filteredData.filter((item) => item.category === selectedCategory))
    } else {
      setFilteredEstimatesData(filteredData)
    }
    setPage(1)
  }, [searchRequest, selectedCategory])

  const estimateColumns = [
    {
      title: 'Наименование',
      dataIndex: 'name',
      render: (name) => <HighlighterWrapper searchWords={[searchRequest]} textToHighlight={name} />,
    },
    {
      title: 'Цена',
      dataIndex: 'price',
    },
    {
      title: 'Кол-во',
      dataIndex: 'amount',
    },
    {
      title: 'Ед. Изм.',
      dataIndex: 'unit',
    },
    {
      title: 'Категория',
      dataIndex: 'category',
    },
    {
      title: 'Действие',
      dataIndex: 'action',
      render: (_, record) => {
        return (
          <div>
            <Button type="link" onClick={() => onUpdate(record)}>
              Выбрать
            </Button>
          </div>
        )
      },
    },
  ]

  const handleCancelCallback = () => {
    setEstimatesData([])
    setFilteredEstimatesData([])
    setCategoryOptions([])
    setSearchRequest('')
    setSelectedCategory(null)
    handleCancel()
  }

  return (
    <Modal
      width={1300}
      title="Выбор позиции из сметы"
      visible={isModalOpen}
      onCancel={handleCancelCallback}
      footer={null}
    >
      <Text>{`Поиск для позиции: `}</Text>
      <Text strong>{`${selectedRecord?.name} / ${selectedRecord?.applicationItemName}`}</Text>
      <div style={{ paddingTop: 15, paddingBottom: 15 }}>
        <Search
          placeholder="Поиск по результатам"
          allowClear
          onSearch={(value) => setSearchRequest(value)}
          value={searchRequest}
          onChange={(e) => setSearchRequest(e.target.value)}
          style={{
            width: 400,
          }}
        />
        <Select
          allowClear
          defaultValue={null}
          options={categoryOptions}
          value={selectedCategory}
          onChange={(value) => setSelectedCategory(value)}
          style={{
            width: 400,
            marginLeft: 15,
          }}
        ></Select>
      </div>
      <Table
        id="estimateTable"
        columns={estimateColumns}
        dataSource={filteredEstimatesData}
        bordered
        size="small"
        pagination={tablePagination}
        loading={isLoading}
      />
    </Modal>
  )
}

export default EstimateAutoSuggestion
